'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropTargetWrapper = require('./components//DragDropTargetWrapper.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropTargetWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drag-drop/lib/components/drag-drop-target-wrapper/index.js
// module id = 1187
// module chunks = 0